<script>
import Clipboard from 'clipboard';
export default {

  props: {
    content: {
      type: String,
      required: true
    },

    buttonType: {
      type: String,
      default: ""
    }
  },

  data() {
    return {
      success: false,
      error: false,
      reference: this._uid
    }
  },

  mounted() {
    this.initCopyToClipboard()
  },

  watch: {
    error() {
      if (!this.error) { return }
      // error occured, copy api not available. Show text input to still allow copying
      this.$nextTick(()=>{
        if (!this.$refs.textInput) { return }
        this.$refs.textInput.$el.children[0].focus()
        this.$refs.textInput.$el.children[0].select()
      })
    }
  },

  computed: {
    cssReference() {
      return `clipboard-${this.reference}`
    }
  },

  methods: {
    initCopyToClipboard() {
      const clipboard = new Clipboard(`.${this.cssReference}`);
      clipboard.on('success', () => {
        this.success = true
        setTimeout(()=>{
          this.success = false
        }, 5000)
      })
      clipboard.on('error', ()=> {
        this.error = true
      })
    }
  }

}
</script>

<template>
  <div class="row" v-if="error">
    <b-input type="textarea" @blur="error = false" :value="content" ref="textInput">
    </b-input>
  </div>
  <b-button v-else-if="success" icon-left="content-copy" :disabled="true">
    Copied!
  </b-button>
  <b-button v-else icon-left="content-copy" :type="buttonType" :class="cssReference" :data-clipboard-text="content">
    <slot></slot>
  </b-button>
</template>